/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationSpotSkills = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationSpotSkills"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        d="M51.95 21.91c2.28 0 4.4-.9 5.97-2.52.92-.95 1.61-2.01 2.14-3.11.05-.08.09-.16.13-.24 0-.02.01-.03.02-.05.1-.21.21-.41.29-.64.04-.13.07-.24.12-.36.25-.67.43-1.35.58-2.02.25-1.06.42-2.11.51-3.28.09-1.23-.1-2.9-.26-3.99-.08-.6-.16-.99-.18-1.1l-.62-3.32-2.4 1.99c-.44.2-.85.36-1.25.5-.57.18-1.27.37-2 .53-.83.15-1.6.22-2.35.28l-.63.06h-.07l-.77-.09-.35.25c-1.64.26-3.3.87-4.98 2.74-1.8 2.01-2.57 4.53-2.31 6.92-1.9.04-3.72.85-5.02 2.25l-2.77 2.98L19.9 3.81l-13.74.03-2.02-.05v1.83L4.1 19.6l16.42 16.43L4.86 52.87a5.25 5.25 0 0 0 .13 7.31c1 1 2.32 1.54 3.73 1.54 1.33 0 2.61-.5 3.59-1.41l16.84-15.66 14.69 14.69c.28.28.59.5.92.7.76.53 1.66.83 2.61.83 1.23 0 2.38-.48 3.25-1.36l6.52-6.61 2.5-2.5c.25-.25.46-.52.64-.8.72-1.05.94-2.34.69-3.54-.18-.92-.62-1.8-1.33-2.51L45.52 29.43l2.52-2.34c.2-.17.45-.4.72-.69.51-.53.93-1.11 1.25-1.75.34-.65.62-1.39.74-2.24.02-.18.04-.38.05-.59.38.05.76.09 1.14.09z"
      />
      <path
        fill="#fff"
        d="M56.49 18c4.62-4.79 2.82-13.02 2.82-13.02-5.99 2.82-8.72.25-11.96 3.87-2.38 2.66-2.53 6.62 0 9.15s6.67 2.57 9.15 0zM19.07 5.81l39.16 39.16a2.843 2.843 0 0 1 0 4.02l-8.94 8.94a2.843 2.843 0 0 1-4.02 0L6.11 18.78l.03-12.93 12.93-.03z"
      />
      <path
        fill="#fff"
        d="m42.63 29.42 4.53-4.21a5.06 5.06 0 0 0 .13-7.3c-2.03-2.03-5.35-1.97-7.3.13l-4.21 4.52 6.85 6.85zM23.42 35.85 6.34 54.23a3.274 3.274 0 0 0 .08 4.54 3.274 3.274 0 0 0 4.54.08l18.37-17.08z"
      />
      <path
        fill="#27DBA8"
        d="M59.3 4.97s.54 2.89.41 4.54-.4 3.16-1.1 5.16-2.8 2.32-2.8 2.32c-1.25-.3-.2-2.81-.76-3.13-.63-.35-3.05.76-3.64-.08-.32-.11.57-3.11.57-3.11-4.79-.89-.3-4.07-.3-4.07 2.32.29 7.05-1.18 7.61-1.64zM49.21 58.12c-1 1.01-2.63 1.02-3.64.01l-3.86-4.01c1.54-1.33 12.9-12.72 12.9-12.72l3.73 3.84c1 1 1 2.61.01 3.61l-9.15 9.28z"
      />
      <path
        fill="#B7E854"
        d="M41.86 54.33 6.21 18.61c1.12.75 3.2 2.61 9.73-3.18 5.44-4.82 3.17-9.54 3.17-9.54l35.5 35.51-12.75 12.92zM39.43 18.75s3-4.53 7.91-.75c3.76 4.56-.86 7.81-.86 7.81l-7.06-7.06z"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="m43.37 29.41 4.12-3.83a5.53 5.53 0 0 0 1.78-3.98 5.5 5.5 0 0 0-.29-1.86c.93.43 1.94.67 2.97.67h.06c1.85-.02 3.56-.75 4.83-2.06 4.75-4.92 3.02-13.13 2.94-13.48l-.13-.61-.57.27c-2.64 1.24-4.6 1.4-6.33 1.55l-1 .09h-.04c-1.66.18-3.17.58-4.75 2.35-2.02 2.25-2.48 5.25-1.41 7.72-.62-.22-1.27-.33-1.96-.32-1.53.03-2.94.66-3.98 1.78l-3.83 4.12L19.43 5.46l-.15-.15-13.63.04-.04 13.63 17.01 17.01-16.64 17.9a3.744 3.744 0 0 0 .1 5.23c.74.74 1.7 1.11 2.67 1.11s1.84-.34 2.57-1.01l17.9-16.64L44.94 58.3c.63.63 1.47.98 2.37.98s1.73-.35 2.37-.98l8.94-8.94c1.3-1.3 1.3-3.43 0-4.73L43.4 29.41zM52 7.14c.27-.03.55-.05.84-.08 1.6-.13 3.56-.29 6.08-1.37.25 1.64.68 6.24-1.32 9.92-1.09 1.1-1.61 1.06-1.74 1.01-.19-.06-.29-.29-.32-.49-.02-.16.06-.46.14-.72.18-.59.45-1.48-.35-1.98-.78-.49-1.56-.15-2.19.11-.68.29-.93.35-1.15.13-.4-.4-.26-.8.14-1.57.26-.5.54-1.03.3-1.53-.16-.34-.51-.56-1.08-.68-.48-.1-1.06-.31-1.1-.73-.06-.61.79-1.58 1.75-2.03zm-4.29 2.04c.73-.81 1.43-1.28 2.15-1.57-.41.53-.66 1.11-.61 1.66.05.57.43 1.32 1.89 1.62.28.06.36.13.37.12 0 .11-.17.45-.27.65-.35.66-.93 1.77.04 2.74.73.73 1.61.36 2.25.09.58-.25.96-.38 1.27-.19.12.08.1.26-.07.84-.12.38-.24.78-.17 1.16.1.64.48 1.12 1 1.28.14.04.28.07.43.07.05 0 .11-.02.17-.03 0 0-.02.02-.02.03-1.08 1.12-2.54 1.74-4.12 1.76a6.22 6.22 0 0 1-4.21-1.68c-.05-.06-.1-.12-.16-.17-.02-.02-.05-.04-.07-.07-2.13-2.28-2.09-5.81.15-8.3zm-4.09 7.74h.09c1.17 0 2.27.45 3.12 1.25.05.06.1.12.16.18.02.02.05.04.08.07.8.87 1.23 1.98 1.21 3.16a4.54 4.54 0 0 1-1.46 3.27l-.33.3-6.44-6.44.3-.33c.85-.92 2.01-1.44 3.27-1.46m-4.26 2.52 6.39 6.39-3.09 2.87-6.17-6.17zm-19.51-9.19c.31-.96.41-1.85.33-2.62l33.75 33.75-5.77 5.77-31.61-31.61c1.57-1.66 2.74-3.53 3.3-5.29M6.63 11.83c1.23.2 2.76-.33 3.96-1.54 1.2-1.2 1.74-2.73 1.54-3.96l6.46-.02c.7.75.81 2.03.3 3.63-.55 1.75-1.76 3.61-3.4 5.25s-3.5 2.85-5.25 3.4c-1.6.51-2.89.4-3.63-.3zm3.99 46.66c-1.1 1.02-2.79.99-3.84-.07a2.763 2.763 0 0 1-.07-3.84l16.61-17.87 5.17 5.17zm-2.7-38.61c.17.02.33.04.51.04.65 0 1.36-.12 2.12-.36 1.77-.56 3.63-1.73 5.29-3.3l31.61 31.61-5.77 5.77zm49.96 28.77-8.94 8.94c-.92.91-2.4.91-3.32 0l-3.25-3.25 12.26-12.25 3.25 3.25c.91.92.91 2.4 0 3.32z"
      />
    </svg>
  );
};
export default IllustrationSpotSkills;
